import { ProjectDto } from '@/core';
import { useMemo } from 'react';
import { sort } from '@/utils';

export const useEpicsOptionsByEpicType = (
  projectData: ProjectDto,
  selectedEpicType: string,
  editedGroupId: string,
) => {
  const usedEpicGroupsIds = projectData.epicGroups
    .filter((group) => group.type === selectedEpicType && group.id !== editedGroupId)
    .reduce((acc, group) => acc.concat(group.epics), [] as string[]);

  return useMemo(
    () =>
      projectData.epics
        .filter((epic) => !usedEpicGroupsIds.includes(epic.id))
        .map((epic) => ({ label: epic.name, value: epic.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData, usedEpicGroupsIds],
  );
};
